import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_chevron-left",
  "use": "icon_chevron-left-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_chevron-left\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.2959 4.15562C10.4489 4.34503 10.4312 4.63292 10.2563 4.79865L6.878 8L10.2563 11.2014C10.4312 11.3671 10.4489 11.655 10.2959 11.8444C10.1429 12.0338 9.87705 12.053 9.70216 11.8872L5.6 8L9.70216 4.11276C9.87705 3.94703 10.1429 3.96622 10.2959 4.15562Z\" fill=\"black\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol